<div class="main-container">
  <div class="container-fluid pt-3 mb-3 pb-3">
    <div class="login">
      <div class="login-section">
        <div class="login-form">
          <div class="login-logo">
            <img src="../../../assets/images/control-logo.png" alt="" />
            <span>Contractor Portal</span>
          </div>

          <h4 class="text-center">Forgot Password</h4>
          <form [formGroup]="form">
            <div class="row">
              <!--<div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Country</mat-label>
                  <mat-select>
                    <mat-option></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>-->
              <div class="col-md-9 col-sm-9 col-9">
                <mat-form-field
                  class="example-form-field full-width"
                  appearance="outline"
                >
                  <mat-label>Email or Mobile</mat-label>
                  <input
                    matInput
                    type="text"
                    required
                    formControlName="username" autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="col-md-3 col-sm-3 col-3 mt-1">
                <button
                  *ngIf="!otpSent || !isTimerEnable"
                  mat-raised-button
                  color="primary"
                  type="button"
                  class="otp"
                  (click)="getOtp()"
                >
                  Get OTP</button
                ><span *ngIf="isTimerEnable" class="otp-count">{{
                  timerText
                }}</span>
              </div>

              <div class="col-md-6 col-sm-6 col-6" *ngIf="otpSent">
                <mat-form-field
                  class="example-form-field full-width"
                  appearance="outline"
                >
                  <mat-label>OTP</mat-label>
                  <input
                    matInput
                    type="password"
                    autocomplete="off"
                    formControlName="otp"
                  />
                </mat-form-field>
              </div>
              <!-- <div class="col-md-6 col-sm-6 col-6">
                    <div class="fp-captcha">
                    <span class="captcha">
                        <span>2+1</span>
                    </span>
                    <span class="refresh">
                        <mat-icon>refresh</mat-icon>
                    </span>
                    </div>
                </div> -->

              <div class="col-md-12 mt-2">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  class="full-width"
                  [disabled]="!otpSent"
                  (click)="submit()"
                >
                  Submit
                </button>
              </div>
              <div class="signup-btn">
                Go to <span (click)="goBack()">Login</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
